import { STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'
import { STATSIG_EXPERIMENTS, useStatsigExperiment } from '@src/experiments/statsig-integration'

export const useCheckoutSharingPiiProtectionExperiment = () => {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.CHECKOUT_SHARING_PII_PROTECTION)
  return (
    experimentBucket === STATSIG_EXPERIMENTS_CONFIG[STATSIG_EXPERIMENTS.CHECKOUT_SHARING_PII_PROTECTION].buckets?.Show
  )
}
